import './admin-ui';
import './primary-menu';
import './anchor-links';
import './social-links';
import './publication';
import './issue-numbers';
import './sidebar';
import './cookie-reposition';
import './stacktable';

(function(jQuery, Drupal) {
  'use strict';
  // 9 times out of 10 it's probably better to make a new file
  // instead of writing code in here.
})(jQuery, Drupal);
